module.exports = __webpack_public_path__ + "static/media/instapage6.7db20392.png";